const ReportsTypes = {
	/** ****************************** SECTION WISE FETCH *********************** */
	REPORT_START: 'reports/report_start',
	REPORT_SUCCESS: 'reports/report_success',
	REPORT_FAILURE: 'reports/report_failure',
	REPORT_RESPONSE_CHANGED: 'reports/report_response_changed',
	REPORT_RESPONSE_REST_START: 'reports/report_response_rest_start',
	GET_MANAGEMENT_LEAVE_REPORT: 'reports/get_management_leave_report_start',
	GET_MANAGEMENT_LEAVE_REPORT_SUCCESS: 'reports/get_management_leave_report_success',
	GET_MANAGEMENT_LEAVE_REPORT_FAILURE: 'reports/get_management_leave_report_failure',
	MANAGEMENT_LEAVE_REPORT_RESET: 'reports/management_leave_report_reset',
	GET_DESIGNATION_LEAVE_REPORT: 'reports/get_designation_leave_report_start',
	GET_DESIGNATION_LEAVE_REPORT_SUCCESS: 'reports/get_designation_leave_report_success',
	GET_DESIGNATION_LEAVE_REPORT_FAILURE: 'reports/get_designation_leave_report_failure',
	DESIGNATION_LEAVE_REPORT_RESET: 'reports/designation_leave_report_reset',
	GET_MONTHLY_ATTENDANCE_SUMMARY_REPORT: 'reports/get_monthly_attendance_summary_report_start',
	GET_MONTHLY_ATTENDANCE_SUMMARY_REPORT_SUCCESS: 'reports/get_monthly_attendance_summary_report_success',
	GET_MONTHLY_ATTENDANCE_SUMMARY_REPORT_FAILURE: 'reports/get_monthly_attendance_summary_report_failure',
	MONTHLY_ATTENDANCE_SUMMARY_REPORT_RESET: 'reports/monthly_attendance_summary_report_reset',
	GET_MONTHLY_CHECKOUT_REPORT: 'reports/get_monthly_checkout_report_start',
	GET_MONTHLY_CHECKOUT_REPORT_SUCCESS: 'reports/get_monthly_checkout_report_success',
	GET_MONTHLY_CHECKOUT_REPORT_FAILURE: 'reports/get_monthly_checkout_report_failure',
	MONTHLY_CHECKOUT_REPORT_RESET: 'reports/monthly_checkout_report_reset'
} as const;

export interface ReportsResponse {
	status: 'success' | 'error';
	data: any;
	message?: string;
}

export default ReportsTypes;
